import React from 'react';
import * as GlobalVariables from '../config/GlobalVariableContext';
import {
  ButtonOutline,
  ButtonSolid,
  Row,
  ScreenContainer,
  StarRating,
  withTheme,
} from '@draftbit/ui';
import { Modal, StyleSheet, Text, View } from 'react-native';

const ReflectEquanimityScreen = props => {
  const Constants = GlobalVariables.useValues();
  const Variables = Constants;
  const setGlobalVariableValue = GlobalVariables.useSetValue();

  const { theme } = props;
  const { navigation } = props;

  const [starRatingValue, setStarRatingValue] = React.useState(0);

  return (
    <ScreenContainer scrollable={false} hasSafeArea={true}>
      <View>
        <Text style={[styles.Texte3364987, { color: theme.colors.strong }]}>
          {'How was your time with your children yesterday?\n'}
        </Text>
      </View>

      <View style={styles.View6f3bcb1e}>
        <Text style={[styles.Textc2499e1c, { color: theme.colors.strong }]}>
          {'Equanimity\n'}
        </Text>

        <Modal
          visible={Constants['Visible']}
          animationType={'slide'}
          presentationStyle={'fullScreen'}
        >
          <Text style={[styles.Texta3db204c, { color: theme.colors.strong }]}>
            {
              '\n\nWere you able to be a safe harbor for your child? Were you able to observe and accept difficult feelings and return to equilibrium quickly? Or were you repeatedly triggered and reactive and unable to let challenging emotions pass through?'
            }
          </Text>
          {/* Close */}
          <ButtonOutline
            onPress={() => {
              try {
                setGlobalVariableValue({
                  key: 'Visible',
                  value: false,
                });
              } catch (err) {
                console.error(err);
              }
            }}
            style={styles.ButtonOutline3975593b}
            title={'Close'}
          />
        </Modal>
        {/* Equanimity Rating */}
        <StarRating
          onPress={newEquanimityRatingValue => {
            try {
              setGlobalVariableValue({
                key: 'equanimity',
                value: newEquanimityRatingValue,
              });
            } catch (err) {
              console.error(err);
            }
          }}
          style={styles.StarRating02f8ec45}
          starSize={32}
          maxStars={5}
          activeColor={theme.colors.primary}
          inactiveColor={theme.colors.light}
          isEditable={true}
          defaultValue={1}
        />
      </View>

      <View style={styles.View2c4fedbd}>
        <Row justifyContent={'space-around'} alignItems={'flex-start'}>
          <ButtonSolid
            onPress={() => {
              try {
                setGlobalVariableValue({
                  key: 'Visible',
                  value: true,
                });
              } catch (err) {
                console.error(err);
              }
            }}
            style={[
              styles.ButtonSolid2d5f6a36,
              { backgroundColor: theme.colors.primary },
            ]}
            title={'Info'}
          />
          <ButtonSolid
            onPress={() => {
              try {
                navigation.navigate('ReflectConnectionScreen');
              } catch (err) {
                console.error(err);
              }
            }}
            style={[
              styles.ButtonSolid9f0cb554,
              { backgroundColor: theme.colors.primary },
            ]}
            title={'Next'}
          />
        </Row>
      </View>
    </ScreenContainer>
  );
};

const styles = StyleSheet.create({
  ButtonOutline3975593b: {
    backgroundColor: 'transparent',
    borderRadius: 8,
    borderWidth: 1,
    fontFamily: 'System',
    fontWeight: '700',
    marginTop: 20,
    textAlign: 'center',
  },
  ButtonSolid2d5f6a36: {
    borderRadius: 8,
    fontFamily: 'System',
    fontWeight: '700',
    textAlign: 'center',
  },
  ButtonSolid9f0cb554: {
    borderRadius: 8,
    fontFamily: 'System',
    fontWeight: '700',
    marginLeft: 20,
    textAlign: 'center',
  },
  StarRating02f8ec45: {
    marginTop: 20,
  },
  Text8189c9ab: {
    marginTop: 20,
    textAlign: 'center',
  },
  Texta3db204c: {
    marginTop: 200,
    textAlign: 'center',
  },
  Textc2499e1c: {
    fontSize: 18,
    textAlign: 'center',
  },
  Texte3364987: {
    fontFamily: 'Roboto_400Regular',
    fontSize: 28,
    marginTop: 40,
    textAlign: 'center',
  },
  View2c4fedbd: {
    alignItems: 'center',
    marginTop: 20,
  },
  View6f3bcb1e: {
    alignItems: 'center',
    marginTop: 150,
  },
});

export default withTheme(ReflectEquanimityScreen);
